import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useAccountVisitCount } from 'Features/auth/api/getAccountVisitCount'
import { useIsFirstLogin } from 'Hooks/useIsFirstLogin'
import { useEffect, useRef } from 'react'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { getAppcuesId } from 'Utils/appcues'

export const useInitialAppcues = () => {
  const isInitialAppcues = useRef(true)
  const { userId, isAdmin, email } = useUserStore()
  const { isPaidMarketingUsed } = useIsFirstLogin()
  const { data: fetchedPlanData } = useGetPlansDetails()
  const { data: limitsData } = useGetPackagingLimits()
  const accountVisitCount = useAccountVisitCount()

  useEffect(() => {
    if (
      window.Appcues &&
      isInitialAppcues.current &&
      userId &&
      fetchedPlanData &&
      accountVisitCount.isFetched &&
      limitsData
    ) {
      isInitialAppcues.current = false
      window.Appcues.identify(getAppcuesId(email), {
        isNoCC: !!fetchedPlanData.noCreditCard,
        isInstallmentsSubscription: !!fetchedPlanData.installmentMonth,
        isInvalidTrafficWidget: true,
        ...(limitsData?.paidMarketingAllowed
          ? getWelcomeExperience(Boolean(isPaidMarketingUsed), isAdmin, accountVisitCount.data)
          : {}),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])
}

const getWelcomeExperience = (
  isPaidMarketingUsed: boolean,
  isAdmin: boolean,
  accountVisitCount: boolean
) => ({
  essentials_first_paid_dashboard_view_post_reg:
    !isPaidMarketingUsed && !isAdmin ? true : accountVisitCount ? false : null,
})
